/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SolidArrowDown = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M16 8C16.824 8 17.2944 8.94076 16.8 9.6L12.8 14.9333C12.4 15.4667 11.6 15.4667 11.2 14.9333L7.2 9.6C6.70557 8.94076 7.17595 8 8 8L16 8Z"
                        fill={color}
                    />
                </svg>
        );
    };
